import { IconButton, Menu, MenuItem, Stack } from "@mui/material";
import { useState } from "react";
import { MoreVertRounded } from "@mui/icons-material";

const FinanceDynamicActions = (props: any) => {

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = !!anchorEl;

    function showInlineActions() {
        return (<Stack direction={"row"} justifyContent={"center"}>{props.children}</Stack>)
    }

    function showHamburgerActions() {
        return (
            <>
                <IconButton id={'hamburger-button'} onClick={(event) => setAnchorEl(event.currentTarget)}>
                    <MoreVertRounded/>
                </IconButton>
                <Menu id={'hamburger-menu'} anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
                    {props.children.map((it: any, index: number) => {
                        if (it !== false)
                            return <MenuItem key={`menu-item-${index}`} onClick={() => setAnchorEl(null)}>{it}</MenuItem>
                        else
                            return null;
                    })}
                </Menu>
            </>
        )
    }

    return (
        <>
            {(!Array.isArray(props.children) || props.children.length <= 2) ? showInlineActions() : showHamburgerActions()}
        </>
    )
}

export default FinanceDynamicActions